export default __webpack_public_path__ + "static/media/3-mobile+hor.02b62833.jpg";